(ns rothko.editor.edit.component
  (:require [rothko.editor.mark.core :as mark]))

;; TODO if we're in original view and we create an edit should we not allow it
;; or change the view to edit. Maybe if there are no edits we can just do it but
;; if there are hidden edits we should not allow it and change the view to
;; edited.

(defn token
  [{:keys [appearance corrected-view?] {:keys [marks word system? misspelled? different?]} :token}]
  (let [not-corrected? (not corrected-view?)]
    [:span.editor__spellcheck
     {:class (when misspelled? :misspelled)}
     [:span.editor__edit
      {:class (cond-> appearance
                not-corrected? (conj :as-edit)
                (and not-corrected? system?) (conj :system-annotation)
                different? (conj :different)
                marks (clojure.set/union (mark/->appearances marks)))}
      word]]))
